
import { defineComponent } from 'vue';
import BCXSkeleton from '@/components/molecules/BCXSkeleton.vue';

export default defineComponent({
  name: 'PartnerProgramCodesSkeleton',
  components: {
    BCXSkeleton,
  },
});
